import {Typography} from '@yandex-delivery/ui'

import {Paper} from '../../../../components/ui'
import styleClasses from './classes@mobile.module.css'

type Props = {
  title: string
  subtitle?: string
}

export function Message({title, subtitle}: Props) {
  return (
    <Paper className={styleClasses.message}>
      <Typography density="normal" level="body2" weight="medium">
        {title}
      </Typography>

      {subtitle && (
        <Typography density="normal" level="caption1" weight="regular">
          {subtitle}
        </Typography>
      )}
    </Paper>
  )
}
